import { useState } from "react";
import { Loader2 } from "lucide-react";

import referralIcon from "assets/images/pregnancy/refferral.svg";
import { HealthlinkXsltFrame } from "features/healthlink/components/HealthlinkXsltFrame/HealthlinkXsltFrame";
import { useReferralXml } from "features/referrals/hooks/useReferralXml";

import switchStyles from "./XMLReferralDataLayerWrapper.module.css";

export const XMLReferralDataLayerWrapper = ({ messageControlId }) => {
  const [viewType, setViewType] = useState("referral");
  const { data, isLoading } = useReferralXml(messageControlId);

  if (isLoading && !data?.xmlContent) {
    return (
      <div className={switchStyles.loadingState}>
        <Loader2 className={switchStyles.loadingSpinner} size={24} />
        <p>Loading referral preview…</p>
      </div>
    );
  }

  if (!data?.xmlContent) {
    return (
      <p className={switchStyles.stateMessage}>
        No referral message found.
      </p>
    );
  }

  if (!data?.xslContent) {
    return (
      <p className={switchStyles.stateMessage}>
        Preview unavailable — the stylesheet for this referral type has not
        been downloaded from Healthlink yet.
      </p>
    );
  }

  const showNavigation = data?.xmlResponses?.length > 0;

  return (
    <div className={switchStyles.wrapper}>
      {showNavigation && (
        <div className={switchStyles.navbar}>
          <div className={switchStyles.navLinks}>
            <button
              onClick={() => setViewType("referral")}
              className={
                viewType === "referral"
                  ? switchStyles.navLinkChecked
                  : switchStyles.navLink
              }
            >
              <img
                src={referralIcon}
                alt="referral icon"
                className={switchStyles.navIcon}
              />
              <span>Referral</span>
            </button>
            <button
              onClick={() => setViewType("response")}
              className={
                viewType === "response"
                  ? switchStyles.navLinkChecked
                  : switchStyles.navLink
              }
            >
              <img
                src={referralIcon}
                alt="response icon"
                className={switchStyles.navIcon}
              />
              <span>Response</span>
            </button>
          </div>
        </div>
      )}
      {viewType === "referral" ? (
        <HealthlinkXsltFrame xml={data.xmlContent} xsl={data.xslContent} />
      ) : (
        data.xmlResponses
          .filter((res) => res.xml)
          .map((res, index) => (
            <HealthlinkXsltFrame
              key={res.id ?? index}
              xml={res.xml}
              xsl={res.xsl || data.xslContent}
              withPrint={false}
            />
          ))
      )}
    </div>
  );
};
